import MainLayout from 'components/layout/MainLayout';
import { useAuthRedirectEffect } from 'hooks/account/useAuthRedirect';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';
import { runningLocally } from 'utils/constants';

const DesignSystemWrapper = observer((props: { children: ReactNode }) => {
  const userStore = useUserStore();
  const router = useRouter();
  const isFullPagePreview = ['/design-system/order-confirmation'].includes(
    router.pathname,
  );

  if (!runningLocally) {
    useAuthRedirectEffect('/design-system');
  }
  if (
    !runningLocally &&
    (!userStore.initialized ||
      !(
        userStore.currentUser?.role === 'ADMIN' ||
        userStore.currentUser?.role === 'OPERATOR'
      ))
  ) {
    return <>"Sorry, you aren't allowed to view this page"</>;
  }

  return (
    <MainLayout limitItemWidths>
      <style>
        {`
          .hackHeadingTextAlign h1,
          .hackHeadingTextAlign h2,
          .hackHeadingTextAlign h3,
          .hackHeadingTextAlign h4 {
            /* The global styles of the site force all headings to be centered. There is no elegant way to override
            this without breaking the existing site. Additionally, responsive layouts may require headings to be centered
            on mobile, but not desktop, etc. Individual pages have to provide their own alignment to override it
            appropriately. The design system page does it here:*/
            text-align: left;
          }
          `}
      </style>
      <div
        className={`aboutUsTypographyReset${isFullPagePreview ? '' : ' hackHeadingTextAlign'}`}
      >
        {props.children}
      </div>
    </MainLayout>
  );
});

export default DesignSystemWrapper;
